import React, { useLayoutEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";

const MicroBarChart = ({ value, maxValue = 100 }) => {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    if (!value) return;

    let raw = typeof value === "object" ? value.value : value;
    let num =
      typeof raw === "string" ? parseFloat(raw.replace(/[^0-9.\-]/g, "")) : raw;
    if (!num) num = 0;

    const root = am5.Root.new(chartRef.current);

    const container = root.container.children.push(
      am5.Container.new(root, {
        width: am5.p100,
        height: am5.p100,
        layout: root.absoluteLayout,
      })
    );

    const barWidth = Math.max(1, (num / maxValue) * 60);

    container.children.push(
      am5.Rectangle.new(root, {
        width: barWidth,
        height: 20,
        fill: am5.color(0x26a69a),
        cornerRadiusTL: 2,
        cornerRadiusTR: 2,
        tooltipText: typeof value === "object" ? value.value : String(value),
      })
    );

    // Add label on bar by default
    container.children.push(
      am5.Label.new(root, {
        text: typeof value === "object" ? value.value : String(value),
        x: barWidth / 2,
        y: 10,
        centerX: am5.p50,
        centerY: am5.p50,
        fill: am5.color(0xffffff), // white text
        fontSize: 10,
      })
    );

    return () => {
      root.dispose(); //  ensures each chart cleans up properly
    };
  }, [value, maxValue]);

  return <div ref={chartRef} style={{ width: "70px", height: "24px" }} />;
};

export default MicroBarChart;
